import { TslDebug } from '@/components/TslDebug';
import TslDebugArea from '@/components/TslDebugArea';
import WebGpuCanvas from '@/components/WebGpuCanvas';
import { OrbitControls, PerspectiveCamera } from '@react-three/drei';
import * as React from 'react';
import { positionLocal } from 'three/tsl';

export type Props = {};

function App03(props: Props) {
  const {} = props;
  return (
    <TslDebugArea>
      {(el) => (
        <WebGpuCanvas>
          <PerspectiveCamera
            makeDefault
            fov={53}
            aspect={el.clientWidth / el.clientHeight}
            near={0.1}
            far={10}
            position={[0, 0, 1]}
          />
          <mesh name="node-mesh">
            <boxGeometry args={[1, 1, 1]} />
            <nodeMaterial fragmentNode={positionLocal.length().mul(15).fract().step(0.5)} />
            <TslDebug meshName={'node-mesh'} />
          </mesh>
          <axesHelper />
          <OrbitControls />
        </WebGpuCanvas>
      )}
    </TslDebugArea>
  );
}

export default React.memo(App03);
